"use client";

import { Menu } from "lucide-react";
import { Link } from "@/i18n/navigation";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { useTranslations } from "next-intl";

interface NavItem {
  title: string;
  items: {
    title: string;
    href: string;
    onClick?: () => void;
  }[];
}

const mobile_nav_link_class_name =
  "block px-2 py-1 rounded-md leading-none no-underline outline-hidden transition-colors hover:bg-gray-50 focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 font-normal";

export function MobileNav() {
  const [open, setOpen] = useState(false);

  const t = useTranslations();

  const navigation: NavItem[] = [
    {
      title: "Who we help",
      items: [
        { title: "Universities", href: "/who-we-help/universities" },
        { title: "FE Colleges", href: "/who-we-help/fe-colleges" },
        { title: "Students", href: "/who-we-help/students" },
        { title: t("general.words.lecturers"), href: "/who-we-help/lecturers" },
        // Training Providers - Temporarily Hidden
        // ...(locale !== 'en-us' ? [{ title: "Training Providers", href: "/book-a-demo" }] : []),
      ],
    },
    {
      title: "How we help",
      items: [
        { title: "AI with Guardrails", href: "/how-we-help/ai-with-guardrails" },
        { title: "Neuroscience", href: "/how-we-help/neuroscience" },
        { title: "Adaptive Learning", href: "/how-we-help/adaptive-learning" },
        { title: "Reduced Workload", href: "/how-we-help/reduced-workload" },
        { title: "Learner Insights", href: "/how-we-help/learner-insights" },
      ],
    },
    {
      title: "About",
      items: [
        { title: "Our Story", href: "/about/our-story" },
        { title: "Advisory Board", href: "/advisory-board" },
        { title: "News and Insights", href: "/about/case-studies" },
        { title: "Events and Webinars", href: "/about/events-webinars" },
        { title: "Trust and Safety Hub", href: "https://trust.studystash.com" },
        { title: t("navbar.help-centre"), href: "https://internal.support.studystash.com/servicedesk/customer/portals" },
      ],
    },
  ];


  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button
          variant="ghost"
          className="mr-2 px-0 text-base hover:bg-transparent focus-visible:bg-transparent focus-visible:ring-0 focus-visible:ring-offset-0 md:hidden"
        >
          <Menu className="h-8 w-8" />
          <span className="sr-only">Toggle menu</span>
        </Button>
      </SheetTrigger>
      <SheetContent side="left" className="pl-1 pr-0 bg-ss-lightest-blue">
        <div className="px-7 pt-6 pb-6 h-full overflow-y-auto">
          <div className="flex flex-col space-y-8">
            {navigation.map((section) => (
              <div key={section.title} className="flex flex-col space-y-2">
                <h4 className="font-medium text-lg">{section.title}</h4>
                <div className="flex flex-col space-y-1.5 bg-white rounded-3xl p-3">
                  {section.items.map((item) => (
                    <Link
                      key={item.href}
                      href={item.href}
                      onClick={item.onClick || (() => setOpen(false))}
                      className={mobile_nav_link_class_name}
                    >
                      {item.title}
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </SheetContent>
    </Sheet>


  );
}
